import script from "./PricingManager.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingManager.vue?vue&type=script&setup=true&lang=js"

import "./PricingManager.vue?vue&type=style&index=0&id=cc676f54&lang=css"

const __exports__ = script;

export default __exports__